import { useState, lazy, Suspense, ReactNode } from 'react';
import { UpgradeModalContext, type UpgradeTrigger } from './upgrade-modal-context';

const UpgradeModal = lazy(() =>
  import('@/components/billing/UpgradeModal').then((m) => ({ default: m.UpgradeModal }))
);

/** Delay before clearing trigger state, matches Dialog close animation */
const MODAL_CLOSE_ANIMATION_MS = 200;

export function UpgradeModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [hasBeenOpened, setHasBeenOpened] = useState(false);
  const [trigger, setTrigger] = useState<UpgradeTrigger | null>(null);

  const openUpgradeModal = (newTrigger: UpgradeTrigger) => {
    setTrigger(newTrigger);
    setIsOpen(true);
    setHasBeenOpened(true);
  };

  const closeUpgradeModal = () => {
    setIsOpen(false);
    // Clear trigger after animation completes
    setTimeout(() => setTrigger(null), MODAL_CLOSE_ANIMATION_MS);
  };

  return (
    <UpgradeModalContext.Provider value={{ openUpgradeModal, closeUpgradeModal }}>
      {children}
      {hasBeenOpened && (
        <Suspense fallback={null}>
          <UpgradeModal isOpen={isOpen} onClose={closeUpgradeModal} trigger={trigger} />
        </Suspense>
      )}
    </UpgradeModalContext.Provider>
  );
}
